import { OrgAdminRoleType } from '@/const/user';
import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { InternalOrganizationUserType } from '@/bundle/_MasterAdmin/types/types';

export type EditInternalOrganizationUserRolePayloadType = {
  role: OrgAdminRoleType;
};

export const editInternalOrganizationUserRoleApi = async (
  userId: string,
  data: EditInternalOrganizationUserRolePayloadType
): Promise<ApiResponseType<InternalOrganizationUserType>> => {
  const uri = `/organization/internal/users/${userId}/role/`;

  return authApiService.PATCH(uri, data);
};
